import { ExceptionDetail } from 'src/models/ExceptionDetail';

export const buildCaseAuthorityException = (error) => {
  return {
    errorCode: error.response.data.errorCode,
    errorStatus: error.response.status,
    errorMessage: error.message,
    retryable: error.retryable
  } as ExceptionDetail;
};
